import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import i18n from 'i18next';
import axios from 'axios';
import { getOnboardingState, getAuthState } from '../../../../store/selectors';
import { getUserData, getCurrentUserId } from '../../../../store/actions';
import countriesList from '../../../../util/countriesList.json';
import Spinner from '../../../../ASUPhotos/spinner.svg';
import AveragePay from './AveragePay';
import JobOpenings from './JobOpenings';
import CareerOutlook from './CareerOutlook';

const BASE_URL = `${process.env.REACT_APP_API}/projected`;

class CareerOneStop extends Component {
  state = {
    projectedEmploymentUSA: null,
    projectedEmploymentState: null,
    projectedSalaryUSA: null,
    projectedSalaryState: null,
    careerOutlook: null,
    stateCode: '',
    isLoading: true,
  };

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    await this.getUserData();
    this.getProjectedSalaryAndEmployment(this.props.career.onetCode);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.career?.onetCode !== prevProps.career?.onetCode &&
      this._isMounted
    ) {
      this.setState({ isLoading: true, ...this.resetData() }, async () => {
        await this.getUserData();
        this.getProjectedSalaryAndEmployment(this.props.career.onetCode);
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  resetData = () => ({
    projectedEmploymentUSA: null,
    projectedEmploymentState: null,
    projectedSalaryUSA: null,
    projectedSalaryState: null,
    careerOutlook: null,
  });

  get apiConfig() {
    return {
      headers: { Authorization: this.props.auth.jwtToken },
    };
  }

  getUserData = async () => {
    if (typeof this.state.userId !== 'number') {
      await this.getUserId();
    }
    await this.props.getUserData(this.state.userId, this.props.auth.jwtToken);
    this.getStateCodeByValue(this.props.onboarding.userData.user.state);
  };

  getUserId = async () => {
    const currentUserId = await this.props.getCurrentUserId(
      this.props.auth.jwtToken
    );
    if (this._isMounted) {
      this.setState({ userId: currentUserId });
    }
  };

  getStateCodeByValue(value) {
    const stateCode = Object.keys(
      countriesList['United States'].territories
    ).find((key) => countriesList['United States'].territories[key] === value);
    if (this._isMounted) {
      this.setState({ stateCode });
    }
  }

  formatSalary = (hourlySalary, annualSalary) =>
    `${hourlySalary.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    })} / hr (${annualSalary.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    })})`;

  getProjectedSalaryAndEmployment = (code) => {
    axios
      .get(`${BASE_URL}/salary/${code}`, this.apiConfig)
      .then((res) => {
        const data = res.data.data;
        const salaryUSA = this.formatSalary(
          data.usWageData.hourlyMean,
          data.usWageData.annualMean
        );
        const salaryState = this.formatSalary(
          data.azWageData.hourlyMean,
          data.azWageData.annualMean
        );

        this.setState({
          projectedSalaryUSA: salaryUSA,
          projectedSalaryState: salaryState,
          projectedEmploymentUSA: data.usWageData.totalEmployment,
          projectedEmploymentState: data.azWageData.totalEmployment,
          careerOutlook: data.tags.brightOutlook
            ? i18n.t('Bright Outlook')
            : false,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.error('Error fetching salary and employment data', error);
        this.setState({ isLoading: false });
      });
  };

  renderComponent = (Component, title, value) =>
    value ? (
      <Component
        modalStyling={this.props.modalStyling}
        titleTextPrimary={{ color: this.props.tenant.primary }}
        titleText={title}
        plainText={value}
      />
    ) : null;

  render() {
    const {
      isLoading,
      projectedSalaryUSA,
      projectedSalaryState,
      projectedEmploymentUSA,
      projectedEmploymentState,
      careerOutlook,
      stateCode,
    } = this.state;

    if (isLoading) {
      return (
        <div
          className="pay-and-openings-loading-spinner"
          style={{ justifyContent: 'center' }}
        >
          <img src={Spinner} alt="Loading..." />
        </div>
      );
    }

    return (
      <Translation>
        {(t) => (
          <div className="pay-and-openings">
            {this.renderComponent(
              AveragePay,
              t('Average National Pay:'),
              projectedSalaryUSA
            )}
            {this.renderComponent(
              JobOpenings,
              t('Job Openings Nationally:'),
              projectedEmploymentUSA
            )}
            {this.renderComponent(
              AveragePay,
              t('Average Pay In {{location}}:', { location: stateCode }),
              projectedSalaryState
            )}
            {this.renderComponent(
              JobOpenings,
              t('Job Openings in {{location}}:', { location: stateCode }),
              projectedEmploymentState
            )}
            {this.renderComponent(
              CareerOutlook,
              t('Bright Outlook'),
              careerOutlook
            )}
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  onboarding: getOnboardingState(state),
  auth: getAuthState(state),
});

export default connect(mapStateToProps, { getUserData, getCurrentUserId })(
  CareerOneStop
);
